const {h, render, Component} = require('preact');

class LanguageDropdownInputView extends Component {
    constructor(props) {
        super(props);
        this.onLanguageChange = this.onLanguageChange.bind(this);
    }

    onLanguageChange(event) {
      var languageElement = document.getElementById("languageDropdown");
      var localeValue = languageElement.options[languageElement.selectedIndex].value;
      this.props.changeLanguageBoxState(localeValue, true)
    }

    componentDidMount() {
      var languageDropdown = document.getElementById("languageDropdown");
      languageDropdown.addEventListener("change", this.onLanguageChange);
    }

    render() {
        return (
            <div class = "form-v2-1">
                <div class = "gig-field focused inputField language-input">
                    <label for = "v2-plaintext-input">Language</label>
                    <select name = "language" aria-label = "LanguageDropDown" id="languageDropdown" label="LanguageDropDown">
                        <label for = "dropdown-input">English</label>
                        <option value = "en_US">English</option>
                        <option value = "es_US">Spanish</option>
                    </select>
                </div>
            </div>
        );
    }
}

module.exports = LanguageDropdownInputView